import React, {useContext, useEffect, useState} from "react";
// styled components
import { Row, Col, Empty, Table, Button } from "antd";
import { Dropdown, Icon } from "semantic-ui-react";
// hooks
import { useMisBeps } from "../../../../hooks/useMisBeps";
// data select
import { cantidadRegistros } from "../../../../utils/dataSelectOptions";
// icons
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
// components
import { ModalVisualizarDocumentos } from "../../../../components/Generales/ModalVisualizarDocumentos";
import { ModalAceptar } from "../../components/ModalAceptar";
import { openNotification } from "../../../../utils/Notifactions";
import { ModalVerPropuesta } from "./ModalVerPropuestaSubsanar";
import {TemplateContext} from "../../../../utils/template_context";
import { ReactComponent as IconFlechareg } from "../../../../assets/flecha_reg.svg";

const coloresEstado: any = {
  "Sin Revisar": "black",
  Aceptado: "#00904C",
  Rechazado: "#DB2828",
  Subsanar: "#F28C02",
  Subsanado: "#6435C9",
};
const TiposIdentificacion: any = { "1": "Persona Natural", "3": "Grupo Conformado", "2": "Persona Juridica" };

export const SubsanarDocumentos = () => {
  const {
    setPostulacion,
    documentossubsanar,
    postulaciones,
    totaldocumentossubsanar,
    cantidadpáginassubsanar,
    cambiarCantidadPaginasDocumentos,
    cargarPostulaciones,
    guardarArchivosAdministrativos,
    cambiarEstadoPostulaciónDocumentos,
    modal,
    setModal,
    descargarArchivo,
    obtenerLineasConvocatorias,
    lineasconvocatoria,
    postulacion,
    verPropuesta,
    setDocumentosSubsanar,
  } = useMisBeps();
  const [modaldocumento, setModalDocumento] = useState<boolean>(false);
  const [documento, setDocumento] = useState<string>("");
  const [tipodocumento, setTipodocumento] = useState<string>("");
  const [indexdocumento, setIndexDocumento] = useState<number>(0);
  const [evento, setEvento] = useState<any>({});
  const [datosdocumento, setDatosDocumento] = useState<any>({});
  const [nombredocumento, setNombreDocumento] = useState<string>("");
  const [aceptarmodaldocumento, setAceptarModalDocumento] = useState<boolean>(false);
  useEffect(() => {
    cargarPostulaciones();
    obtenerLineasConvocatorias();
  }, []);
  //   functions
  const AceptarModalDocumento = async () => {
    documentossubsanar[indexdocumento].estado = "Subsanado";
    await guardarArchivosAdministrativos(datosdocumento, evento, indexdocumento, postulaciones);
    await cambiarEstadoPostulaciónDocumentos();
    return setAceptarModalDocumento(false);
  };
  const CancelarModalDocumento = () => {
    return setAceptarModalDocumento(false);
  };
  // pagination table
  function itemRenderTable(current: any, type: any, originalElement: any) {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
        </span>
      );
    }
    return originalElement;
  }
  //   columns
  // const columns: any = [
  //   {
  //     title: "No.",
  //     width: 40,
  //     render: (datos: any, datos2: any, index: number) => {
  //       return (
  //         <>
  //           <span>{index + 1}</span>
  //         </>
  //       );
  //     },
  //     fixed: context.device === "md"? "left": false,
  //   },
  //   {
  //     title: "Nombre proyecto",
  //     width: 200,
  //     fixed: context.device === "md"? "left": false,
  //     dataIndex: "nombre_propuesta",
  //     key: "nombre_propuesta",
  //   },
  //   {
  //     title: "Codigo propuesta",
  //     width: 100,
  //     dataIndex: "radicado",
  //     key: "radicado",
  //   },
  //   {
  //     title: "Tipo documento",
  //     width: 200,
  //     dataIndex: "tipo_documento",
  //     key: "tipo_documento",
  //   },
  //   {
  //     title: "Estado",
  //     width: 100,
  //     render: (datos: any) => {
  //       return (
  //         <>
  //           <span style={{ color: coloresEstado[datos.estado] }}>{datos.estado}</span>
  //         </>
  //       );
  //     },
  //   },
  //   {
  //     title: "Tipo participante",
  //     width: 140,
  //     render: (datos: any) => {
  //       // console.log(datos);
  //       return (
  //         <>
  //           <span>{TiposIdentificacion[datos.tipo_participante]}</span>
  //         </>
  //       );
  //     },
  //   },
  //   {
  //     title: "Linea",
  //     width: 120,
  //     dataIndex: "numero_documento_participante",
  //     key: "numero_documento_participante",
  //   },
  //   {
  //     title: "Categoría",
  //     width: 169,
  //     render: (datos: any) => {
  //       // console.log(datos);
  //       return (
  //         <>
  //           {/* <span>{datos.categoria_linea_convocatoria ? datos.categoria_linea_convocatoria[0].value : null}</span> */}
  //         </>
  //       );
  //     },
  //   },
  //   {
  //     title: () => (
  //       <div className="width-100">
  //         <div span={24} className="justify-content-center">
  //           Acciones
  //         </div>
  //       </div>
  //     ),
  //     width: 140,
  //     fixed: context.device === "lg"? "right": false,
  //     render: (datos: any, datos2: any, index: number) => (
  //       <>
  //         <div className="width-100">
  //           <div span={24} className="justify-content-center">
  //             <Button
  //               onClick={() => {
  //                 setModalDocumento(true);
  //                 setDocumento(datos.url_participante);
  //               }}
  //               className="no-margin button-azul-ghost font-family-Montserrat-Medium"
  //             >
  //               VER
  //             </Button>
  //             <Button
  //               onClick={() => {
  //                 var inputs: HTMLElement = document.getElementsByClassName("inputs-ref-subsanable-mis-postulaciones")[
  //                   index
  //                 ] as HTMLElement;
  //                 inputs.click();
  //                 return setIndexDocumento(index);
  //               }}
  //               className="no-margin button-azul-ghost font-family-Montserrat-Medium"
  //             >
  //               SUBSANAR
  //             </Button>
  // <input
  //   className="inputs-ref-subsanable-mis-postulaciones"
  //   type="file"
  //   hidden
  //   onChange={(e: any) => {
  //     if (e.target.files!.length > 0) {
  //       if (e.target.files[0].type === "application/pdf") {
  //         const { name } = e.target.files![0];
  //         setTipodocumento(datos.descripcion);
  //         setNombreDocumento(name);
  //         setDatosDocumento(datos);
  //         setEvento(e);
  //         setPostulacionState(documentossubsanar[index]);
  //         return setAceptarModalDocumento(true);
  //       }
  //       return openNotification({
  //         titulo: "Error",
  //         descripcion: "Solo se permiten archivos PDF",
  //         placement: "bottomRight",
  //       });
  //     }
  //   }}
  // />
  //           </div>
  //         </div>
  //       </>
  //     ),
  //   },
  // ];
    const context = useContext(TemplateContext);
  // columns postulation
  const columns: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
      fixed: context.device === "md"? "left": false,
    },
    {
      title: "Nombre proyecto",
      width: 200,
      fixed: context.device === "md"? "left": false,
      dataIndex: "nombre_propuesta",
      key: "nombre_propuesta",
    },
    {
      title: "Código propuesta",
      width: 100,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{datos.radicado}</span>
          </>
        );
      },
    },
    {
      title: "Estado",
      width: 100,
      render: (datos: any) => {
        return (
          <>
            <span style={{ color: coloresEstado[datos.estado] }}>{datos.estado}</span>
          </>
        );
      },
    },
    {
      title: "Tipo participante",
      width: 140,
      render: (datos: any) => {
        return (
          <>
            <span>{TiposIdentificacion[datos.tipo_participante]}</span>
          </>
        );
      },
    },
    {
      title: "Linea",
      width: 120,
      render: (datos: any) => {
        return (
          <>
            <span>
              {datos.linea_convocatoria}
            </span>
          </>
        );
      },
    },
    {
      title: "Categoría",
      width: 169,
      render: (datos: any) => {
        return (
          <>
            <span>
              {datos.categoria_linea_convocatoria}
            </span>
          </>
        );
      },
    },
    {
      title: () => (
        <div className="row">
          <div className="col-12 justify-content-center">
            Acciones
          </div>
        </div>
      ),
      width: 90,
      fixed: context.device === "lg"? "right": false,
      render: (datos: any) => (
        <>
          <div className="row">
            <div className="col-12 justify-content-center">
              <Button
                onClick={() => verPropuesta(datos)}
                className="no-margin button-azul-ghost font-family-Montserrat-Medium"
              >
                Ver Más
              </Button>
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <div>
      <div className="row mt-4">
        <div className="col-12 font-family-Montserrat-Regular font-size-14px">
          {" "}
          Si tienes documentos pendientes por subsanar, usa la acción "Ver más" y "Subsanar documento" para cargar un nuevo archivo y enviarlo a revisión.
        </div>
        <div className="col-12">
          <div className="row-shadow2 ms-1">
		  
			<div className="row pb-2">
               <div className="col-12 pb-2 col-md-6 font-size-14px font-family-Montserrat-SemiBold">
                  Gestionar postulación de proyectos
               </div>
               <div className="col-12 col-md-6">
                  <div className="row g-2">
                     <div className="col-10 col-md-10  col-xl-10 col-xxl-11  d-flex justify-content-end align-content-center">
                        <span className="pe-4 col d-flex justify-content-md-end font-size-12px">
                        Total : <span className="font-color-F28C02">{totaldocumentossubsanar}</span>
                        </span>  
                        <span className="d-flex flex-nowrap pt-1 justify-content-end font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                        Registros por página
                        </span>
                     </div>
                     <div className="col-2 col-md-2 col-xl-2 col-xxl-1 justify-content-between">
                        <Dropdown
                        fluid
                        className="select-registros-adminconvocatoria no-margin"
                        defaultValue={cantidadpáginassubsanar}
                        options={cantidadRegistros}
                        icon={<IconFlechareg/>
                    }
                        onChange={(e, { value }) => cambiarCantidadPaginasDocumentos(e, value)}
                        />
                     </div>
                  </div>
               </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-12">
                <Table
                  style={{ borderTop: "1px solid #C4C4C4" }}
                  locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                  pagination={{
                    position: ["bottomRight"],
                    itemRender: itemRenderTable,
                    pageSize: cantidadpáginassubsanar,
                  }}
                  columns={columns}
                  dataSource={documentossubsanar}
                  scroll={{ x: 1500, y: 300 }}
                  size="small"
                  rowClassName="sizeTable table-row"
                  className="table-ant-design-modify"
                  bordered={false}
                />
              </div>
            </div>
          </div>
          <ModalVerPropuesta
            modal={modal}
            AceptarModal={() => setModal(false)}
            postulacion={postulacion}
            setPostulacion={setPostulacion}
            allpostulaciones={documentossubsanar}
            setAllPostulaciones={setDocumentosSubsanar}
            descargarArchivo={descargarArchivo}
            CancelarModal={() => setModal(false)}
            lineasConvocatoria={lineasconvocatoria}
          />
        </div>
      </div>
      {/* <ModalVisualizarDocumentos
        visualizar={modaldocumento}
        setVisualizar={setModalDocumento}
        state={{ documento: documento }}
        tipo="participante"
      />
      <ModalAceptar
        modal={aceptarmodaldocumento}
        AceptarModal={AceptarModalDocumento}
        CancelarArchivo={CancelarModalDocumento}
        CancelarModal={() => setAceptarModalDocumento(false)}
        TipoDocumento={tipodocumento}
        NombreArchivo={nombredocumento}
      /> */}
    </div>
  );
};
